import React from "react";
import PropTypes from "prop-types";

export default function Document(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9988 5.85762C18.9972 5.71343 18.9414 5.57215 18.8354 5.46612L14.533 1.16458C14.5328 1.16439 14.5327 1.16434 14.5325 1.1642C14.4309 1.06272 14.2905 1 14.1356 1H2.18328C1.53079 1 1 1.53063 1 2.18299V23.817C1 24.4693 1.53074 25 2.18324 25H17.8168C18.4692 25 19 24.4694 19 23.817V5.86343C19.0001 5.86137 18.999 5.85963 18.9988 5.85762ZM14.6976 2.91864L17.081 5.30149H14.7568C14.7242 5.30149 14.6976 5.27491 14.6976 5.24234V2.91864ZM17.8759 23.8171C17.8759 23.8496 17.8494 23.8762 17.8168 23.8762H2.18328C2.1507 23.8762 2.12416 23.8496 2.12416 23.8171V2.18299C2.12416 2.15041 2.1507 2.12388 2.18328 2.12388H13.5735V5.24234C13.5735 5.89465 14.1044 6.42542 14.7569 6.42542H17.876V23.8171H17.8759Z"
        fill="#BCC8E8"
      />
      <path
        d="M14.974 8.68817H5.02611C4.71573 8.68817 4.46405 8.93975 4.46405 9.25011C4.46405 9.56042 4.71573 9.81205 5.02611 9.81205H14.9739C15.2843 9.81205 15.536 9.56042 15.536 9.25011C15.536 8.93975 15.2843 8.68817 14.974 8.68817Z"
        fill="#BCC8E8"
      />
      <path
        d="M14.974 12.0791H5.02611C4.71573 12.0791 4.46405 12.3307 4.46405 12.641C4.46405 12.9513 4.71573 13.2029 5.02611 13.2029H14.9739C15.2843 13.2029 15.536 12.9513 15.536 12.641C15.536 12.3307 15.2843 12.0791 14.974 12.0791Z"
        fill="#BCC8E8"
      />
      <path
        d="M14.974 15.4699H5.02611C4.71573 15.4699 4.46405 15.7215 4.46405 16.0319C4.46405 16.3422 4.71573 16.5938 5.02611 16.5938H14.9739C15.2843 16.5938 15.536 16.3422 15.536 16.0319C15.536 15.7216 15.2843 15.4699 14.974 15.4699Z"
        fill="#BCC8E8"
      />
      <path
        d="M10 18.8609H5.02611C4.71573 18.8609 4.46405 19.1125 4.46405 19.4228C4.46405 19.7332 4.71573 19.9847 5.02611 19.9847H10C10.3104 19.9847 10.5621 19.7332 10.5621 19.4228C10.5621 19.1124 10.3104 18.8609 10 18.8609Z"
        fill="#BCC8E8"
      />
      <path
        d="M18.9988 5.85762C18.9972 5.71343 18.9414 5.57215 18.8354 5.46612L14.533 1.16458C14.5328 1.16439 14.5327 1.16434 14.5325 1.1642C14.4309 1.06272 14.2905 1 14.1356 1H2.18328C1.53079 1 1 1.53063 1 2.18299V23.817C1 24.4693 1.53074 25 2.18324 25H17.8168C18.4692 25 19 24.4694 19 23.817V5.86343C19.0001 5.86137 18.999 5.85963 18.9988 5.85762ZM14.6976 2.91864L17.081 5.30149H14.7568C14.7242 5.30149 14.6976 5.27491 14.6976 5.24234V2.91864ZM17.8759 23.8171C17.8759 23.8496 17.8494 23.8762 17.8168 23.8762H2.18328C2.1507 23.8762 2.12416 23.8496 2.12416 23.8171V2.18299C2.12416 2.15041 2.1507 2.12388 2.18328 2.12388H13.5735V5.24234C13.5735 5.89465 14.1044 6.42542 14.7569 6.42542H17.876V23.8171H17.8759Z"
        stroke="#BCC8E8"
        strokeWidth="0.2"
      />
      <path
        d="M14.974 8.68817H5.02611C4.71573 8.68817 4.46405 8.93975 4.46405 9.25011C4.46405 9.56042 4.71573 9.81205 5.02611 9.81205H14.9739C15.2843 9.81205 15.536 9.56042 15.536 9.25011C15.536 8.93975 15.2843 8.68817 14.974 8.68817Z"
        stroke="#BCC8E8"
        strokeWidth="0.2"
      />
      <path
        d="M14.974 12.0791H5.02611C4.71573 12.0791 4.46405 12.3307 4.46405 12.641C4.46405 12.9513 4.71573 13.2029 5.02611 13.2029H14.9739C15.2843 13.2029 15.536 12.9513 15.536 12.641C15.536 12.3307 15.2843 12.0791 14.974 12.0791Z"
        stroke="#BCC8E8"
        strokeWidth="0.2"
      />
      <path
        d="M14.974 15.4699H5.02611C4.71573 15.4699 4.46405 15.7215 4.46405 16.0319C4.46405 16.3422 4.71573 16.5938 5.02611 16.5938H14.9739C15.2843 16.5938 15.536 16.3422 15.536 16.0319C15.536 15.7216 15.2843 15.4699 14.974 15.4699Z"
        stroke="#BCC8E8"
        strokeWidth="0.2"
      />
      <path
        d="M10 18.8609H5.02611C4.71573 18.8609 4.46405 19.1125 4.46405 19.4228C4.46405 19.7332 4.71573 19.9847 5.02611 19.9847H10C10.3104 19.9847 10.5621 19.7332 10.5621 19.4228C10.5621 19.1124 10.3104 18.8609 10 18.8609Z"
        stroke="#BCC8E8"
        strokeWidth="0.2"
      />
    </svg>
  );
}

Document.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Document.defaultProps = {
  className: "",
  width: 20,
  height: 26
};
